(() => {
  if (window.idealCartFeedbackInstalled) return;
  const notice = document.querySelector('[data-ideal-cart-feedback]');
  const configNode = document.querySelector('[data-ideal-cart-feedback-config]');
  if (!notice || !configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }

  window.idealCartFeedbackInstalled = true;
  document.body.classList.add('ideal-cart-feedback-enabled');
  document.body.appendChild(notice);

  const title = notice.querySelector('[data-ideal-cart-feedback-title]');
  const detail = notice.querySelector('[data-ideal-cart-feedback-detail]');
  const link = notice.querySelector('[data-ideal-cart-feedback-link]');
  const liveRegion = notice.querySelector('[role="status"]');
  const attempts = [];
  const cartAddPath = /\/cart\/add(?:\.js)?(?:\?|$)/i;
  // Searchspring's Snap bundle (snapui.searchspring.io/l4qwst/bundle.js) still carries a copy of the
  // old grid quick-buy handler, which appends its own green "Added N item(s) to cart" div to <body>.
  // Hide it so there is one toast. Delete this once that block is removed from the Snap project.
  const snapNotice = /^Added\s+\d+\s+item\(s\)\s+to\s+cart\.?$/i;
  let snapObserver = null;
  let snapObserverTimer = null;
  let dismissTimer = null;
  let positionFrame = 0;
  let positionObserver = null;
  let positionTargets = [];
  let silentRequestDepth = 0;

  window.idealCartFeedback = Object.assign(window.idealCartFeedback || {}, {
    runSilently(operation) {
      silentRequestDepth += 1;
      try {
        return operation();
      } finally {
        silentRequestDepth -= 1;
      }
    }
  });

  function updateNoticePosition() {
    positionFrame = 0;
    const viewport = window.visualViewport;
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
    let headerBottom = viewportTop;
    positionTargets.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.bottom <= viewportTop || rect.top >= viewportBottom) return;
      const style = window.getComputedStyle(element);
      if (style.visibility === 'hidden' || style.visibility === 'collapse' || style.display === 'none') return;
      headerBottom = Math.max(headerBottom, rect.bottom);
    });
    const top = `${Math.ceil(headerBottom + 12)}px`;
    if (notice.style.getPropertyValue('--ideal-cart-feedback-top') !== top) {
      notice.style.setProperty('--ideal-cart-feedback-top', top);
    }
  }

  function scheduleNoticePosition() {
    if (!notice.hidden && !positionFrame) positionFrame = window.requestAnimationFrame(updateNoticePosition);
  }

  function stopNoticePosition() {
    window.cancelAnimationFrame(positionFrame);
    positionFrame = 0;
    if (positionObserver) positionObserver.disconnect();
    positionObserver = null;
    window.removeEventListener('scroll', scheduleNoticePosition);
    window.removeEventListener('resize', scheduleNoticePosition);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('scroll', scheduleNoticePosition);
      window.visualViewport.removeEventListener('resize', scheduleNoticePosition);
    }
  }

  function trackNoticePosition() {
    stopNoticePosition();
    const header = document.querySelector('[data-site-header]');
    positionTargets = header
      ? [header, ...header.querySelectorAll('[data-site-header-main], .site-header-right, .site-header__account-links')]
      : [];
    updateNoticePosition();
    if (window.ResizeObserver) {
      positionObserver = new ResizeObserver(scheduleNoticePosition);
      positionTargets.forEach(element => positionObserver.observe(element));
    }
    window.addEventListener('scroll', scheduleNoticePosition, { passive: true });
    window.addEventListener('resize', scheduleNoticePosition, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', scheduleNoticePosition, { passive: true });
      window.visualViewport.addEventListener('resize', scheduleNoticePosition, { passive: true });
    }
  }

  function close() {
    clearTimeout(dismissTimer);
    notice.hidden = true;
    stopNoticePosition();
  }

  function scheduleDismiss(ms) {
    clearTimeout(dismissTimer);
    if (notice.matches(':hover') || notice.contains(document.activeElement)) return;
    dismissTimer = setTimeout(close, ms);
  }

  function show(state, heading, message) {
    if (document.body.classList.contains('template-cart')) {
      close();
      return;
    }
    clearTimeout(dismissTimer);
    notice.dataset.state = state;
    title.textContent = heading;
    detail.textContent = message || '';
    detail.hidden = !message;
    link.hidden = state !== 'success';
    liveRegion.setAttribute('role', state === 'error' ? 'alert' : 'status');
    liveRegion.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
    trackNoticePosition();
    notice.hidden = false;
    if (state !== 'pending') scheduleDismiss(state === 'error' ? 7000 : 4500);
  }

  function restore(attempt) {
    if (!attempt) return;
    clearTimeout(attempt.timeout);
    attempt.button.removeAttribute('data-ideal-cart-busy');
    if (attempt.busy === null) attempt.button.removeAttribute('aria-busy');
    else attempt.button.setAttribute('aria-busy', attempt.busy);
    if (attempt.label && attempt.label.isConnected) attempt.label.textContent = attempt.originalLabel;
    if (attempt.ariaLabel === null) attempt.button.removeAttribute('aria-label');
    else attempt.button.setAttribute('aria-label', attempt.ariaLabel);
  }

  function formatQuantity(quantity) {
    const template = (quantity === 1 ? config.one : config.many) || 'Item added to cart';
    return template.replace('__quantity__', String(quantity));
  }

  // `requested` is the quantity read from the cart/add request; it covers adds with no recorded
  // attempt, such as the Searchspring search dropdown's quantity input (submitted on Enter).
  function finish(success, description, requested) {
    const attempt = attempts.shift();
    restore(attempt);
    if (success) {
      if (!attempt && notice.dataset.state === 'success' && !notice.hidden) return;
      const quantity = requested || (attempt ? attempt.quantity : 1);
      const message = attempt && attempt.name
        ? quantity + ' × ' + attempt.name
        : (description || formatQuantity(quantity));
      show('success', config.success, message);
    } else {
      show('error', config.error, description || config.error_help);
    }
  }

  function isCartAdd(url, method) {
    return typeof url === 'string' && cartAddPath.test(url) &&
      String(method || 'GET').toUpperCase() === 'POST';
  }

  function hideSnapNotice(node) {
    if (!(node instanceof HTMLDivElement) || node.id || node.closest('#ideal-cart-feedback')) return;
    if (!snapNotice.test((node.textContent || '').trim())) return;
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
  }

  // Snap appends its div after its follow-up /cart.js call, so watch <body> for a while after each add.
  function watchSnapNotice() {
    if (!snapObserver) {
      snapObserver = new MutationObserver(records => {
        for (const record of records) record.addedNodes.forEach(hideSnapNotice);
      });
      snapObserver.observe(document.body, { childList: true });
    }
    clearTimeout(snapObserverTimer);
    snapObserverTimer = setTimeout(() => {
      snapObserver.disconnect();
      snapObserver = null;
    }, 10000);
  }

  // Shared by the fetch and XHR hooks: `body` is the parsed cart/add.js response, or null when unreadable.
  function settle(ok, body, quantity) {
    if (ok) {
      if (body && (body.id || Array.isArray(body.items))) {
        finish(true, undefined, quantity);
        watchSnapNotice();
      }
      return;
    }
    finish(false, body && typeof body.description === 'string' ? body.description : config.error_help);
  }

  function parseBody(text) {
    try { return JSON.parse(text); } catch { return null; }
  }

  // Total quantity in a cart/add request body (FormData, URLSearchParams, form-encoded or JSON string),
  // or null when it can't be read. Shopify treats a missing quantity as 1.
  function requestQuantity(body) {
    const count = value => Math.max(1, Number.parseInt(value, 10) || 1);
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return count(body.get('quantity'));
      if (typeof body !== 'string') return null;
      if (!/^\s*\{/.test(body)) return count(new URLSearchParams(body).get('quantity'));
      const data = JSON.parse(body);
      if (Array.isArray(data.items)) return data.items.reduce((sum, item) => sum + count(item.quantity), 0) || null;
      return count(data.quantity);
    } catch { return null; }
  }

  function start(event) {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    // data-ss-quick-buy: Searchspring Snap grid buttons on collection and search pages.
    const button = event.target.closest('button[data-quick-buy], button[data-ss-quick-buy], button[data-product-atc]');
    begin(button);
  }

  function begin(button, requestedQuantity) {
    if (!button || button.disabled || button.classList.contains('disabled') ||
      button.hasAttribute('data-ideal-cart-busy')) return;
    const product = button.closest('[data-product-item]');
    const form = button.closest('form[data-product-form]') ||
      button.closest('[data-ideal-pdp]')?.querySelector('.product-main form[data-product-form]');
    const input = product ? product.querySelector('[data-ss-quantity-input], [data-quantity-input]') :
      form ? form.querySelector('[data-quantity-input]') : null;
    const quantity = Math.max(1, Number.parseInt(requestedQuantity ?? (input && input.value), 10) || 1);
    const name = product
      ? product.querySelector('.productitem--title a')?.textContent?.trim()
      : document.querySelector('.product-title, .product__title, h1.product-title')?.textContent?.trim();
    const label = button.querySelector('.atc-button--text, .product-form--atc-button--text');
    const attempt = {
      button, label, quantity, name,
      originalLabel: label ? label.textContent : null,
      ariaLabel: button.getAttribute('aria-label'),
      busy: button.getAttribute('aria-busy'),
      timeout: null
    };
    attempts.push(attempt);
    button.setAttribute('data-ideal-cart-busy', '');
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = config.button_pending;
    button.setAttribute('aria-label', config.button_pending);
    show('pending', config.pending, '');
    attempt.timeout = setTimeout(() => {
      const index = attempts.indexOf(attempt);
      if (index < 0) return;
      attempts.splice(index, 1);
      restore(attempt);
      if (notice.dataset.state === 'pending') close();
    }, 13000);
  }

  document.addEventListener('click', start, true);
  document.addEventListener('ideal:cart-add-start', event => {
    const button = event.detail?.button;
    if (button instanceof HTMLButtonElement && button.matches('[data-ideal-pdp-history-order-again]')) {
      begin(button, event.detail.quantity);
    }
  });

  const previousFetch = window.fetch;
  window.fetch = function(input, options) {
    const url = typeof input === 'string' ? input : input && input.url;
    const method = (options && options.method) || (input && input.method);
    const shouldReport = isCartAdd(url, method) && silentRequestDepth === 0;
    const response = previousFetch.apply(this, arguments);
    if (shouldReport) {
      const quantity = requestQuantity(options && options.body);
      Promise.resolve(response).then(result => {
        if (!result) return settle(false, null);
        return result.clone().text().then(
          text => settle(result.ok, parseBody(text), quantity),
          () => settle(result.ok, null, quantity)
        );
      }).catch(error => settle(false, error?.name === 'IdealReorderError' ? { description: error.message } : null));
    }
    return response;
  };

  // The theme's product form (jquery.cart.js) posts cart/add.js over XHR, not fetch. Wrap the
  // constructor rather than the prototype: theme.liquid already wraps it the same way and overrides
  // open/send per instance, so prototype patches would never run.
  const PreviousXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = function() {
    const xhr = new PreviousXHR();
    const previousOpen = xhr.open;
    const previousSend = xhr.send;
    xhr.open = function(method, url) {
      this.idealCartAdd = isCartAdd(url, method);
      return previousOpen.apply(this, arguments);
    };
    xhr.send = function(data) {
      if (this.idealCartAdd && silentRequestDepth === 0) {
        const quantity = requestQuantity(data);
        this.addEventListener('load', () => {
          const body = this.responseType === 'json' ? this.response : parseBody(this.responseText);
          settle(this.status >= 200 && this.status < 300, body, quantity);
        });
        this.addEventListener('error', () => settle(false, null));
        this.addEventListener('abort', () => settle(false, null));
        this.addEventListener('timeout', () => settle(false, null));
      }
      return previousSend.apply(this, arguments);
    };
    return xhr;
  };
  Object.setPrototypeOf(window.XMLHttpRequest.prototype, PreviousXHR.prototype);
  Object.setPrototypeOf(window.XMLHttpRequest, PreviousXHR);

  notice.querySelector('[data-ideal-cart-feedback-close]').addEventListener('click', close);
  notice.addEventListener('pointerenter', () => clearTimeout(dismissTimer));
  notice.addEventListener('pointerleave', () => {
    if (notice.dataset.state !== 'pending') scheduleDismiss(2500);
  });
  notice.addEventListener('focusin', () => clearTimeout(dismissTimer));
  notice.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (notice.dataset.state !== 'pending') scheduleDismiss(2500);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !notice.hidden) close();
  });
})();

